import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=64b1a93f&scoped=true&"
import script from "./change-password.vue?vue&type=script&lang=js&"
export * from "./change-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b1a93f",
  null
  
)

export default component.exports